const e = "_section_1no5y_1", o = "_preamble_1no5y_9", s = {
  section: e,
  preamble: o
};
export {
  s as default,
  o as preamble,
  e as section
};
